module.exports = __webpack_public_path__ + "img/logo-dark.3a5d4966.png";